import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "title is-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " error ", -1)
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "control has-icons-right" }
const _hoisted_7 = ["id", "type", "placeholder", "onUpdate:modelValue"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "control has-icons-right"
}
const _hoisted_10 = ["id", "type", "placeholder", "autocomplete", "onUpdate:modelValue"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "field"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_strength = _resolveComponent("password-strength")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.activeTab.label), 1),
    _hoisted_3,
    _createElementVNode("form", {
      class: "auth-form",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["error", { expanded: _ctx.error }])
      }, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controls, (control) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "field",
          key: control.key
        }, [
          _createElementVNode("label", {
            class: "label is-medium",
            for: control.key
          }, _toDisplayString(control.label), 9, _hoisted_5),
          (_ctx.activeTab.key === 'signUp' && control.key === 'password')
            ? (_openBlock(), _createBlock(_component_password_strength, {
                key: 0,
                password: _ctx.controls[1].value,
                showPasswordSuggestions: _ctx.showPasswordSuggestions
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPasswordSuggestions = true)),
                      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPasswordSuggestions = false)),
                      id: control.key,
                      type: control.type,
                      placeholder: control.placeholder,
                      autocomplete: "new-password",
                      "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                    }, null, 40, _hoisted_7), [
                      [_vModelDynamic, control.value]
                    ]),
                    (control.key === 'password')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: ($event: any) => {
                control.show = !control.show; 
                control.type === 'password' ? control.type = 'text' : control.type = 'password'},
                          class: "icon is-small is-right material-icons input-icon",
                          style: {"pointer-events":"all","cursor":"pointer"}
                        }, _toDisplayString(control.show ? 'visibility' : 'visibility_off'), 9, _hoisted_8))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["password", "showPasswordSuggestions"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  id: control.key,
                  type: control.type,
                  placeholder: control.placeholder,
                  autocomplete: control.key === 'password' ? 'current-password' : 'email',
                  "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelDynamic, control.value]
                ]),
                (control.key === 'password')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: ($event: any) => {
              control.show = !control.show; 
              control.type === 'password' ? control.type = 'text' : control.type = 'password'},
                      class: "icon is-small is-right material-icons input-icon",
                      style: {"pointer-events":"all","cursor":"pointer"}
                    }, _toDisplayString(control.show ? 'visibility' : 'visibility_off'), 9, _hoisted_11))
                  : _createCommentVNode("", true)
              ]))
        ]))
      }), 128)),
      (_ctx.activeTab.key === 'login')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("a", {
              href: "",
              class: "reset-password",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
            }, " Forgot password? ")
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_custom_button, {
        type: "submit",
        style: {"margin-top":"1.2rem"},
        onClick: _ctx.submitForm,
        loadingState: _ctx.submitted,
        errorMessage: _ctx.error
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.activeTab.label), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loadingState", "errorMessage"])
    ], 32)
  ]))
}